const PERKS_PRICING = [
  { id: 'netflix', productId: ['netflix'], price: [0, 0, 10, 25, 50, 125] },
  { id: 'spotify', productId: ['spotify'], price: [0, 0, 5, 25, 50, 100] },
  {
    id: 'gaming',
    productId: ['playstation', 'xbox', 'steam'],
    price: [0, 0, 0, 25, 50, 125]
  }
]

const buildPerkUrl = ({ id, name }, { firstName, lastName, email, authId }) => {
  return `https://cdbewjpd3gf.typeform.com/to/qaZnzYbB#name=${firstName} ${lastName}&email=${encodeURIComponent(email)}&user_id=${authId}&product_id=${id}&product_name=${name}`
}

export { PERKS_PRICING, buildPerkUrl }
